const storeDataFunc = (props, data, storeKey) => {
    if(storeKey.length === 1) {
        if(props[storeKey[0]] !== undefined) {
            data = props[storeKey[0]]
        }
    }else if(storeKey.length === 2) {
        if(props[storeKey[0]] !== undefined){
            if( props[storeKey[0]][storeKey[1]] !== undefined) {
                data = props[storeKey[0]][storeKey[1]]
            }
        }
    }else if(storeKey.length === 3) {
        if(props[storeKey[0]] !== undefined){
            if( props[storeKey[0]][storeKey[1]] !== undefined) {
                if(props[storeKey[0]][storeKey[1]][storeKey[2]] !== undefined) {
                    data = props[storeKey[0]][storeKey[1]][storeKey[2]]
                }
            }
        }
    }else if(storeKey.length === 4) {
        if(props[storeKey[0]] !== undefined){
            if( props[storeKey[0]][storeKey[1]] !== undefined) {
                if(props[storeKey[0]][storeKey[1]][storeKey[2]] !== undefined) {
                    if(props[storeKey[0]][storeKey[1]][storeKey[2]][storeKey[3]] !== undefined){
                        data = props[storeKey[0]][storeKey[1]][storeKey[2]][storeKey[3]]
                    }
                }
            }
        }
    }else if(storeKey.length === 5) {
        if(props[storeKey[0]] !== undefined){
            if( props[storeKey[0]][storeKey[1]] !== undefined) {
                if(props[storeKey[0]][storeKey[1]][storeKey[2]] !== undefined) {
                    if(props[storeKey[0]][storeKey[1]][storeKey[2]][storeKey[3]] !== undefined){
                        if(props[storeKey[0]][storeKey[1]][storeKey[2]][storeKey[3]][storeKey[4]] !== undefined) {                                            
                            data = props[storeKey[0]][storeKey[1]][storeKey[2]][storeKey[3]][storeKey[4]]
                        }
                    }
                }
            }
        }
    }

  
    
    return data;
}

export default storeDataFunc;


// WEBPACK FOOTER //
// ./src/_components/common/Form2/dropdownStore.js